/*
 * @FileName       : report.reducer.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : report reducer to handle report events.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import createReducer from './createReducer';
import { InvoicesActions } from '../actions';
import { INVOICES } from '../constants/actions';

export const invoices = createReducer(
	{},
	{
		[INVOICES.LIST_RESPONSE](state = {}, action: ReturnType<typeof InvoicesActions.successInvoiceList>) {
			return { ...state, invoicesList: action.payload };
		},

		[INVOICES.SET_PAYMENT_CONFIRMED](state = {}, action: ReturnType<typeof InvoicesActions.setPaymentConfirmed>) {
			return { ...state, paymentIsConfirmed: action.payload };
		},

		[INVOICES.CLEAR_INVOICES_LIST](state = {}, action: ReturnType<typeof InvoicesActions.clearInvoicesList>) {
			return { ...state, invoicesList: [] };
		},

		[INVOICES.SET_REQUESTS](state = {}, action: ReturnType<typeof InvoicesActions.setInvoiceRequests>) {
			return { ...state, invoiceRequests: action.payload };
		},
	},
);
